import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Link,
  Stack,
  Typography
} from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import { AuthForm } from 'hooks/useAuthForm';
import VerificationCodeInput from 'components/VerificationCodeInput';
import IdentifierField from './IdentifierField';
import SubmitError from './SubmitError';
import YandexLoginButton from './YandexLoginButton';

export default function RegisterForm({ auth }: { auth: AuthForm }) {
  const { form, ui, loading, counter, submitError, fieldErrors } = auth;

  return (
    <Stack
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (ui.isSubmitted && counter > 0) return;
        auth.handleSendOtp();
      }}
      spacing={2}
      sx={{ mt: 1, flex: 1 }}
    >
      {!ui.isSubmitted ? (
        <>
          <Typography variant="body1" fontWeight={500}>
            Укажите ваш {auth.fieldLabel.toLowerCase()}
          </Typography>
          <Box sx={{ height: 80 }}>
            <IdentifierField
              otpStrategy={auth.otpStrategy}
              value={form.identifier}
              onChange={auth.handleIdentifierChange}
              onBlur={auth.handleIdentifierBlur}
              error={fieldErrors.identifier}
              placeholder={auth.fieldPlaceholder}
              autoComplete={auth.fieldAutoComplete}
              autoFocus
            />
          </Box>
          <FormControlLabel
            control={
              <Checkbox
                checked={ui.consentChecked}
                onChange={(e) => auth.updateUi({ consentChecked: e.target.checked })}
                size="small"
              />
            }
            label={
              <Typography variant="caption">
                Даю{' '}
                <Link
                  component="button"
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    auth.updateUi({ privacyDialogOpen: true });
                  }}
                  sx={{ verticalAlign: 'baseline' }}
                >
                  согласие
                </Link>{' '}
                на обработку своих персональных данных и соглашаюсь с{' '}
                <Link component={RouterLink} to="/static/privacy-policy.pdf" target="_blank">
                  политикой конфиденциальности
                </Link>
              </Typography>
            }
          />
          <Box sx={{ mt: 'auto !important' }}>
            {form.identifier.length > 0 && !fieldErrors.identifier && !submitError && (
              <Typography sx={{ mb: 1 }} variant="caption" color="text.secondary">
                Мы пришлём четырёхзначный код для входа
              </Typography>
            )}
            <SubmitError error={submitError} />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              disabled={
                !!fieldErrors.identifier ||
                form.identifier.length === 0 ||
                loading ||
                !ui.consentChecked
              }
              sx={{ mt: submitError ? 1 : 0 }}
            >
              {loading ? 'Отправка...' : 'Запросить код'}
            </Button>
            <Divider sx={{ my: 2 }}>или</Divider>
            <YandexLoginButton />
          </Box>
        </>
      ) : (
        <>
          <Box>
            <VerificationCodeInput error={submitError} onSubmit={auth.handleVerifyOtp} />
          </Box>
          <Typography variant="body2" color="text.secondary">
            {auth.otpSentHint}
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            disabled={counter > 0 || loading}
            sx={{ mt: 'auto !important' }}
          >
            {loading
              ? 'Отправка...'
              : counter > 0
              ? `Запросить повторно через 00:${counter < 10 ? '0' + counter : counter}`
              : 'Запросить код повторно'}
          </Button>
        </>
      )}
    </Stack>
  );
}
